function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "15",
  viewBox: "0 0 16 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".8",
  d: "M.569 13.832c.403.404.991.364 1.664.07l11.942-5.336c.303-.135.543-.284.707-.448.379-.379.379-.857 0-1.236-.164-.164-.409-.309-.707-.448L2.178 1.083C1.575.809.972.764.568 1.168.08 1.656.24 2.214.595 2.857L3.134 7.5.618 12.098c-.368.668-.543 1.24-.05 1.734zm3.906-7.015L2.462 3.041c-.04-.09-.04-.13-.01-.16.035-.034.075-.044.154-.004l7.503 3.337c.618.27 1.26.494 1.993.768-.687-.07-1.514-.16-2.152-.16l-5.475-.005zm-2.028 5.316c-.035-.035-.025-.084.02-.17L4.47 8.188l5.48-.01c.618 0 1.49-.084 2.167-.164-.732.274-1.385.498-2.008.772l-7.498 3.343c-.084.035-.13.04-.164.005z",
  fill: "#12002D"
})));